import React, { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SettingsPopup } from '../SettingsPopup'
import { save } from './actions'
import { getFormData, uiSchema } from './utils/rjsf'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { useOpenModalOpenSection } from '../../../store/modals/hooks/useOpenModalOpenSection'

import './rjsfStyles.scss'
import { useSettingsPopupState } from '../hooks'
import { useSchema } from './hooks'
import { featuresSchema } from '../../../store/features/featuresSchema'
import {
  featureAvailabilitiesSelector,
  featureValuesSelector
} from '../../../store/features/selectors'

export const FeaturesPopup: React.FC = memo(() => {
  const dispatch = useDispatch()
  const features = useSelector(featureValuesSelector('userSettings'))
  const openSection = useOpenModalOpenSection() ?? 'form'
  const availabilities = useSelector(featureAvailabilitiesSelector)
  const schema = useSchema()

  const { initialFormData, formData, onFormDataChange } = useSettingsPopupState(
    () => getFormData(features, featuresSchema, availabilities),
    [openSection, availabilities]
  )

  return (
    <SettingsPopup
      className="features-popup-modal"
      openSection={openSection}
      uiSchema={uiSchema}
      schema={schema}
      formData={formData}
      initialFormData={initialFormData}
      onChange={onFormDataChange}
      save={features => dispatch(save(features))}
      close={() => dispatch(modalsActions.closeModal())}
      validationErrorsByField={{}}
    />
  )
})
